export const FETCHING_CONTACTS = 'FETCHING_CONTACTS';
export const FETCHING_CONTACTS_SUCCESS = 'FETCHING_CONTACTS_SUCCESS';
export const FETCHING_CONTACTS_FAILURE = 'FETCHING_CONTACTS_FAILURE';

export const FETCHING_TASKS = 'FETCHING_TASKS';
export const FETCHING_TASKS_SUCCESS = 'FETCHING_TASKS_SUCCESS';
export const FETCHING_TASKS_FAILURE = 'FETCHING_TASKS_FAILURE';

export const FETCHING_PROJECTS = 'FETCHING_PROJECTS';
export const FETCHING_PROJECTS_SUCCESS = 'FETCHING_PROJECTS_SUCCESS';
export const FETCHING_PROJECTS_FAILURE = 'FETCHING_PROJECTS_FAILURE';

export const FETCHING_MEMBERS = 'FETCHING_MEMBERS';
export const FETCHING_MEMBERS_SUCCESS = 'FETCHING_MEMBERS_SUCCESS';
export const FETCHING_MEMBERS_FAILURE = 'FETCHING_MEMBERS_FAILURE';

export const AUTH_STATE_SUBSCRIBE = 'AUTH_STATE_SUBSCRIBE';
export const AUTH_STATE_PUBLISH = 'AUTH_STATE_PUBLISH';
export const AUTH_STATE_FAILURE = 'AUTH_STATE_FAILURE';
export const AUTH_STATE_UNSUBSCRIBE = 'AUTH_STATE_UNSUBSCRIBE';
export const AUTH_SIGNIN_REQUEST = 'AUTH_SIGNIN_REQUEST';
export const AUTH_SIGNIN_SUCCESS = 'AUTH_SIGNIN_SUCCESS';
export const AUTH_SIGNIN_FAILURE = 'AUTH_SIGNIN_FAILURE';
export const AUTH_SIGNOUT_REQUEST = 'AUTH_SIGNOUT_REQUEST';
export const AUTH_SIGNOUT_SUCCESS = 'AUTH_SIGNOUT_SUCCESS';
export const AUTH_SIGNOUT_FAILURE = 'AUTH_SIGNOUT_FAILURE';

export const AUTH_USER_PROFILE_SUBSCRIBE = 'AUTH_USER_PROFILE_SUBSCRIBE';
export const AUTH_USER_PROFILE_PUBLISH = 'AUTH_USER_PROFILE_PUBLISH';
export const AUTH_USER_PROFILE_PUBLISH_BLANK = 'AUTH_USER_PROFILE_PUBLISH_BLANK';
export const AUTH_USER_PROFILE_UNSUBSCRIBE = 'AUTH_USER_PROFILE_UNSUBSCRIBE';
export const AUTH_USER_PROFILE_UPDATE_REQUEST = 'AUTH_USER_PROFILE_UPDATE_REQUEST';
export const AUTH_USER_PROFILE_UPDATE_SUCCESS = 'AUTH_USER_PROFILE_UPDATE_SUCCESS';
export const AUTH_USER_PROFILE_UPDATE_FAILURE = 'AUTH_USER_PROFILE_UPDATE_FAILURE';

export const APP_NETWORK_ONLINE = 'APP_NETWORK_ONLINE';
export const APP_NETWORK_OFFLINE = 'APP_NETWORK_OFFLINE';

export const APP_REALTIME_CLIENT_DATA_SUBSCRIBE = 'APP_REALTIME_CLIENT_DATA_SUBSCRIBE';
export const APP_REALTIME_CLIENT_DATA_UNSUBSCRIBE = 'APP_REALTIME_CLIENT_DATA_UNSUBSCRIBE';

export const VEHICLES_REALTIME_DATA_SUBSCRIBE = 'VEHICLES_REALTIME_DATA_SUBSCRIBE';
export const VEHICLES_REALTIME_DATA_PUBLISH = 'VEHICLES_REALTIME_DATA_PUBLISH';
export const VEHICLES_REALTIME_DATA_FAILURE = 'VEHICLES_REALTIME_DATA_FAILURE';
export const VEHICLES_REALTIME_DATA_UNSUBSCRIBE = 'VEHICLES_REALTIME_DATA_UNSUBSCRIBE';

export const DRIVERS_REALTIME_DATA_SUBSCRIBE = 'DRIVERS_REALTIME_DATA_SUBSCRIBE';
export const DRIVERS_REALTIME_DATA_PUBLISH = 'DRIVERS_REALTIME_DATA_PUBLISH';
export const DRIVERS_REALTIME_DATA_FAILURE = 'DRIVERS_REALTIME_DATA_FAILURE';
export const DRIVERS_REALTIME_DATA_UNSUBSCRIBE = 'DRIVERS_REALTIME_DATA_UNSUBSCRIBE';

export const VEHICLE_TRACKING_STATUSES_REALTIME_DATA_SUBSCRIBE = 'VEHICLE_TRACKING_STATUSES_REALTIME_DATA_SUBSCRIBE';
export const VEHICLE_TRACKING_STATUSES_REALTIME_DATA_PUBLISH = 'VEHICLE_TRACKING_STATUSES_REALTIME_DATA_PUBLISH';
export const VEHICLE_TRACKING_STATUSES_REALTIME_DATA_FAILURE = 'VEHICLE_TRACKING_STATUSES_REALTIME_DATA_FAILURE';
export const VEHICLE_TRACKING_STATUSES_REALTIME_DATA_UNSUBSCRIBE = 'VEHICLE_TRACKING_STATUSES_REALTIME_DATA_UNSUBSCRIBE';

export const FLEETS_REALTIME_DATA_SUBSCRIBE = 'FLEETS_REALTIME_DATA_SUBSCRIBE';
export const FLEETS_REALTIME_DATA_PUBLISH = 'FLEETS_REALTIME_DATA_PUBLISH';
export const FLEETS_REALTIME_DATA_FAILURE = 'FLEETS_REALTIME_DATA_FAILURE';
export const FLEETS_REALTIME_DATA_UNSUBSCRIBE = 'FLEETS_REALTIME_DATA_UNSUBSCRIBE';
export const FLEET_CREATE_REQUEST = 'FLEET_CREATE_REQUEST';
export const FLEET_CREATE_SUCCESS = 'FLEET_CREATE_SUCCESS';
export const FLEET_CREATE_FAILURE = 'FLEET_CREATE_FAILURE';



// WEBPACK FOOTER //
// ./src/actionTypes.js